module.exports = __webpack_public_path__ + "img/17-13.68d25791.jpg";